import React, { useState, useEffect } from "react";
import axios from "axios";
import WeatherForecastDay from "./WeatherForecastDay";
import "./WeatherForecast.css";


export default function WeatherForecast(props) {
    const[loaded, setLoaded] = useState(false)
    const[forecast, setForecast] = useState(null)

    useEffect(() => {
        setLoaded(false);
    }, [props.data.city]);

    function handleForecastResponse(response) {
        console.log(response.data.daily[1].temperature.maximum);
        setForecast(response.data.daily);
        setLoaded(true);
    }

    function searchForecast(){
    const apiKey = "d102f34aao5ce8t34e64ea7aab7a37d2";
    let apiUrl = `https://api.shecodes.io/weather/v1/forecast?query=${props.data.city}&key=${apiKey}`;
    
    axios.get(apiUrl).then(handleForecastResponse);
    }

    if (loaded) {
        return ( <div className="WeatherForecast">
    <div className="row">   
        {forecast.map(function(dailyForecast, index){
            if (index < 6){
            return(  
            <div className="col" key={index}>
            <WeatherForecastDay data={dailyForecast}/>
            </div>) 
            } else {
                return null;
            }
        })}
        </div>
         </div>
        );
    } else {
        searchForecast();
        return null;
    }
}